import { render, staticRenderFns } from "./CompanyEmailDocumentModal.vue?vue&type=template&id=7faaaaa0&scoped=true&"
import script from "./CompanyEmailDocumentModal.vue?vue&type=script&lang=js&"
export * from "./CompanyEmailDocumentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faaaaa0",
  null
  
)

export default component.exports